import React from 'react';

function OtpIcon(props) {
  return (
    <span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_216_1769)">
          <g clipPath="url(#clip1_216_1769)">
            <path
              d="M9.16675 2.5H17.5001V9.16667H15.0001L11.6667 10.8333V9.16667H9.16675V2.5Z"
              stroke="#363636"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5001 13.3334V16.6667C12.5001 16.8878 12.4123 17.0997 12.256 17.256C12.0997 17.4123 11.8878 17.5001 11.6667 17.5001H5.00008C4.77907 17.5001 4.56711 17.4123 4.41083 17.256C4.25455 17.0997 4.16675 16.8878 4.16675 16.6667V5.00008C4.16675 4.77907 4.25455 4.56711 4.41083 4.41083C4.56711 4.25455 4.77907 4.16675 5.00008 4.16675H6.66675"
              stroke="#363636"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.33325 15V15.0083"
              stroke="#363636"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_216_1769">
            <rect width="20" height="20" fill="white" />
          </clipPath>
          <clipPath id="clip1_216_1769">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}

export default OtpIcon;
